/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { useHygraphImageLoader } from "@cosmos/components";
import Image, { ImageProps } from "next/image";

import { css } from "@panda/css";

/**
 * Uses Next's Image component.  When width isn't specified it will use fill with position relative.
 * https://nextjs.org/docs/app/api-reference/components/image#fill
 */
export const CustomImage = (props: ImageProps): React.JSX.Element => {
	const hygraphImageLoader = useHygraphImageLoader();

	const validWidth = !!props.width;
	let style = { ...props.style };
	let newWidth = props.width;
	let newHeight = props.height;
	if (!validWidth) {
		// Fixes the next error: 'has both "height" and "fill" properties. Only one should be used.'
		newWidth = undefined;
		newHeight = undefined;

		//console.warn("CustomImage attempting to use fill for an image that does not have width/height specified", props);
		style = {
			objectFit: "contain",
		};
	}

	const imgEl = (
		<Image
			loader={hygraphImageLoader}
			{...props}
			width={newWidth}
			height={newHeight}
			alt={props.alt || ""}
			fill={!validWidth}
			style={style}
		/>
	);

	return validWidth ? (
		imgEl
	) : (
		<div
			className={css({
				position: "relative",
				width: "100%",
				height: "100%",
				"& img": {
					position: "relative !important",
				},
			})}
		>
			{imgEl}
		</div>
	);
};
